import task from "@commons/task";
import {sa2Toast, sa2Confirm, sa2Alert} from "@commons/sa2Custom";
import {__t} from "@commons/i18nRef";
import useFormUtils from "@commons/useFormUtils";
import Utils from "../../../Utils/Utils";

export default function privateUseForm(content, nextState, vrs) { // content div della view
    const {context, requestData, assetType} = vrs.session;

    var modal = $(content).closest('.modal');
    var errorMsgEl = $(".user-msg", content).hide().html("");

    var form = $("form", content);
    var FormUtils = useFormUtils(form);

    var xhrPost = null;

    $(form).off().on("submit", function (e) {
        e.preventDefault();

        $(errorMsgEl).hide().html("");

        FormUtils.clearErrors();
        context.setLoading(true);

        xhrPost = $.post(task("Booking.registerPrivateUse"), $(form).serialize(), function (response) {

            if (response.success) {

                if (response.message && response.message.trim()) {
                    sa2Alert(response.message, "info");
                }

                $(modal).modal('hide');

            } else {

                $(errorMsgEl).show().html(response.message);

                if (response.hasOwnProperty('errorFields')) {
                    FormUtils.showErrors(response.errorFields);
                }
            }

        }, "json").fail(function (jqxhr, textStatus, error) {
        }).always(function () {
            context.setLoading(false);
        });

        vrs.registerXhrs(xhrPost);
    });


    return function () {
        $(errorMsgEl).hide().html("");
        FormUtils.clearErrors();
        FormUtils.reset()
    }

}
